import React from 'react';
import './SearchPage.css';
import TuneIcon from '@material-ui/icons/Tune';
import ChannelRow from './ChannelRow';


function SearchPage() {
    return (
        <div className="searchPage">
            <div className="searchPage__filter">
                <TuneIcon />
                <h2>Filter</h2>
                <hr />
            </div>
            <hr />
            <ChannelRow
                image="https://scontent-lht6-1.xx.fbcdn.net/v/t1.0-1/c86.34.779.779a/s160x160/36488192_1161423437334088_1792426638739243008_n.jpg?_nc_cat=100&_nc_sid=dbb9e7&_nc_ohc=znED-YNh02oAX95eONJ&_nc_ht=scontent-lht6-1.xx&oh=b554b309eb0110454b3964684f42a78f&oe=5F4A2A8D"
                channel="Sambulo Senda"
                verified
                subs="780K"
                noOfVideos={399}
                description=" React, GraphQL, JavaScript tutorials. 330+ free video programming tutorials (React, JavaScript, PHP, Java, Sass, Grunt, Gulp, Node.js, WordPress, Yeoman, React, Objective-C and much more)."
            />

            < hr />

        </div>
    )
}

export default SearchPage
